import { render, staticRenderFns } from "./MaterialLink.vue?vue&type=template&id=22fa98c8&scoped=true&"
import script from "./MaterialLink.vue?vue&type=script&lang=js&"
export * from "./MaterialLink.vue?vue&type=script&lang=js&"
import style0 from "./MaterialLink.vue?vue&type=style&index=0&id=22fa98c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa98c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DownloadArrow: require('/vercel/path0/components/icons/DownloadArrow.vue').default})
